function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.63568 5.62917L6.69618 6.68967C5.28018 8.10567 4.50018 9.98967 4.50018 11.9922C4.50018 15.9312 7.56168 19.1337 11.4257 19.4322L9.87618 17.4852L11.0492 16.5507L14.1227 20.4147L10.2602 23.4897L9.32568 22.3152L11.0537 20.9397C6.53418 20.4672 3.00018 16.6347 3.00018 11.9922C3.00018 9.58917 3.93618 7.32867 5.63568 5.62917ZM13.7381 0.495117L14.6726 1.66962L12.9461 3.04362C17.4641 3.51762 20.9981 7.34862 20.9981 11.9926C20.9981 14.3956 20.0621 16.6561 18.3626 18.3556L17.3021 17.2951C18.7181 15.8791 19.4981 13.9951 19.4981 11.9926C19.4981 8.05362 16.4366 4.84962 12.5726 4.55112L14.1221 6.49812L12.9491 7.43262L9.87558 3.57012L13.7381 0.495117Z",
  fill: "currentColor"
});

var SvgReloadIcon = function SvgReloadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReloadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ReloadIcon.cdeab61d.svg";
export { ForwardRef as ReactComponent };